<template>
    <svg viewBox="0 0 24 24" width="24" height="24">
        <path d="M2,21L23,12L2,3V10L17,12L2,14V21Z" style="fill: currentcolor;"></path>
    </svg>
</template>